<template>
<div>
    <b-table
        id="clicks-table"
        class="table-panels"
        :busy.sync="isBusy"
        :items="clickthroughProvider"
        :fields="fields"
        sort-by="created_at"
        :sort-desc="true"
        fixed
        borderless
        sort-icon-right
        :per-page="pagination.perPage"
        :current-page="pagination.currentPage"
    >
        <template #cell(participant_id)="data">
            <div class="creator-wrapper my-auto d-flex" v-if="creatorsByParticipantId[data.item.participant_id]">
                <b-img-lazy
                    :src="creatorsByParticipantId[data.item.participant_id].participant.platform_user_logo"
                    class="avatar my-auto"
                />

                <div
                    class="name-rank-wrapper d-flex flex-column my-auto ml-3"
                >
                    <span class="h6 m-0">
                        {{ creatorsByParticipantId[data.item.participant_id].participant.platform_user_name }}

                        <verified-badge
                            v-if="creatorsByParticipantId[data.item.participant_id].superview.channel.is_partner"
                            :platform="'twitch'"
                        />
                    </span>

                    <small
                        :style="{
                            color: getColors.ranks[creatorsByParticipantId[data.item.participant_id].superview.rank.name]
                        }"
                    >
                        {{ creatorsByParticipantId[data.item.participant_id].superview.rank.name | capitalize }}
                    </small>
                </div>
            </div>
        </template>
    </b-table>

    <div class="d-flex">
        <b-pagination
            class="mx-auto"
            :total-rows="totalRows"
            :per-page="pagination.perPage"
            v-model="pagination.currentPage"
         />
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import numeral from 'numeral'
import VerifiedBadge from '@/components/Client/VerifiedBadge'

export default {
    components: {
        VerifiedBadge,
    },

    props: {
        supercampaign_id: {
            type: String,
        },

        campaign_id: {
            type: String,
        },

        link: {
            type: Object,
        },

        totalRows: {
            type: Number,
            default: 0,
        },

        creatorsByParticipantId: {
            type: Object,
        }
    },

    watch: {
        link(newValue) {
            this.$root.$emit('bv::refresh::table', 'clicks-table')
        }
    },

    data() {
        return {
            isBusy: false,

            pagination: {
                perPage: 10,
                currentPage: 1,
                totalRows: 100,
            },

            fields: [{
                key: 'participant_id',
                label: 'Creator',
                sortable: false,
            }, {
                key: 'fingerprint',
                label: 'Fingerprint',
                sortable: false,
            }, {
                key: 'hits',
                label: 'Hits',
                sortable: true,
                class: 'text-center',
                formatter: (value, key, item) => {
                    return numeral(value).format('0,0')
                },
            }, {
                key: 'geolocation',
                label: 'Location',
                formatter: (value, key, item) => {
                    const { city, region_code, country_code } = value

                    if (city && region_code && country_code) {
                        return `${city}, ${region_code}, ${country_code}`
                    } else if (region_code && country_code) {
                        return `${region_code}, ${country_code}`
                    } else if (country_code) {
                        return `${country_code}`
                    } else {
                        return `---`
                    }
                },
                sortable: true,
                sortByFormatted: true,
                filterByFormatted: true,
            }, {
                key: 'created_at',
                label: 'Time',
                sortable: true,
                sortDirection: 'desc',
                formatter: (value, key, item) => {
                    return moment(value).calendar()
                },
            }],
        }
    },

    computed: {
        ...mapGetters([
            'getColors'
        ]),
    },

    methods: {
        clickthroughProvider(ctx) {
            console.log(ctx)

            const params = {
                offset: (ctx.currentPage - 1) * ctx.perPage,
                limit: ctx.perPage,
                order_field: ctx.sortBy,
                order_direction: ctx.sortDesc ? 'desc' : 'asc',
            }

            if (this.link) {
                params.link_id = this.link.id
            }

            return this.axios.get(`/supercampaigns/${this.supercampaign_id}/campaigns/${this.campaign_id}/clickthroughs`, {
                params,
            }).then(({ data }) => {
                this.isBusy = false
                return data.payload.clickthroughs
            }).catch((error) => {
                console.error(`Error in table provider`, error)
                this.isBusy = false
                return []
            })
        }
    }
}
</script>

<style lang="scss" scoped>
#clicks-table {
    border-collapse:separate;
    border-spacing: 0 0.5rem;
    transition: opacity 0.25s;

    &[aria-busy="true"] {
        opacity: 0.5;
    }

    thead {
        th {
            font-weight: 400;
            line-height: 1.3;
            color: #f6f6f8;
            font-size: 1rem;
        }
    }

    tbody {
        tr {
            background: rgba(white, 0.05);
            border-radius: 5px;
            margin-bottom: 5px;

            &:hover {
                background-color: rgba(white, 0.075);
            }

            td {
                vertical-align: middle;
            }

            td:first-child {
                border-top-left-radius: 12px;
                border-bottom-left-radius: 12px;
            }

            td:last-child {
                border-top-right-radius: 12px;
                border-bottom-right-radius: 12px;
            }
        }
    }
}
</style>
